import { ReactNode } from 'react';

interface InfoSectionHeaderProps {
  children: ReactNode;
}

/**
 * InfoSectionHeader - Section header for info panels
 *
 * Styled with a light background and bold text per design system.
 * Use within side panels to create consistent section headers.
 *
 * @example
 * ```tsx
 * <InfoSectionHeader>Basic information</InfoSectionHeader>
 * ```
 */
export function InfoSectionHeader({ children }: InfoSectionHeaderProps) {
  return (
    <div className='bg-surface-focus-support px-(--info-gutter) py-4'>
      <h3 className='size-p1 text-primary font-bold'>{children}</h3>
    </div>
  );
}
